<template>
    <div class="d-flex justify-content-center">
       <iframe class="mx-auto" src="/iframe_html/index.html" width="1350" height="900" id="f" name="myIframe" scrolling="yes"></iframe>
    </div>
</template>
<script>
import axios from 'axios'


export default {
    data(){
        return{
            unique_key:this.$route.params
        }
    },
    mounted(){
        window.localStorage.removeItem('unique_key')
        window.localStorage.setItem('unique_key',JSON.stringify(this.$route.params));
    }

}
</script>